var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"cursor-pointer",on:{"click":_vm.check}},[_c('div',{staticClass:"checker inv-checker"},[_c('span',{class:{ 'checked' : _vm.checked }})]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }